import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import RewardsGrid from '../components/Grid';
import { RewardProvider } from '../store';

import RewardFormLayout from './Form';

export default function RewardsGridLayout() {
  return <RewardProvider>
    <RewardsGrid />
    <Router>
      <PrivateRoute path={["/cms/rewards/add", "/cms/rewards/:id"]} component={RewardFormLayout} />
    </Router>
  </RewardProvider>
}
